console.log("accordion.js");

/**
 * Crée un container par groupe de frères <details>
 */
function ajouterContainersAccordion() {
  const detailsElements = document.querySelectorAll("main details.accordion");

  if (detailsElements.length === 0) return;

  const groups = new Map();

  // 1. Regrouper par parent direct
  detailsElements.forEach((details) => {
    const parent = details.parentElement;
    if (!parent) return;

    if (!groups.has(parent)) {
      groups.set(parent, []);
    }

    groups.get(parent).push(details);
  });

  // 2. Pour chaque groupe de frères
  groups.forEach((items, parent) => {
    if (items.length === 0) return;

    const container = document.createElement("div");
    container.classList.add("accordion-container");

    // Insérer le container avant le premier item
    parent.insertBefore(container, items[0]);

    // Déplacer les <details> dedans
    items.forEach((details) => {
      container.appendChild(details);
    });
  });
}

/**
 * Ouvre le premier accordion de chaque container si aucun n'est ouvert
 */
function deplierPremierBlocParDefaut() {
  const containers = document.querySelectorAll(".accordion-container");

  containers.forEach((container) => {
    const accordions = container.querySelectorAll("details.accordion");

    const hasOpen = Array.from(accordions).some((d) => d.open);

    if (!hasOpen && accordions.length > 0) {
      accordions[0].open = true;
    }
  });
}

/**
 * Comportement accordion par container
 */
function activerComportementAccordion() {
  const containers = document.querySelectorAll(".accordion-container");

  containers.forEach((container) => {
    const accordions = container.querySelectorAll("details.accordion");

    accordions.forEach((details) => {
      details.addEventListener("toggle", () => {
        if (!details.open) return;

        accordions.forEach((other) => {
          if (other !== details) {
            other.open = false;
          }
        });
      });
    });
  });
}

/**
 * Ouverture clavier
 */
function ouvrirBoutonIcon() {
  const boutons = document.querySelectorAll(".accordion__icon--open");

  boutons.forEach((bouton) => {
    bouton.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        const details = bouton.closest("details");
        if (details) details.open = true;
      }
    });
  });
}

/**
 * Fermeture clavier
 */
function fermerBoutonIcon() {
  const boutons = document.querySelectorAll(".accordion__icon--close");

  boutons.forEach((bouton) => {
    bouton.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        const details = bouton.closest("details");
        if (details) details.open = false;
      }
    });
  });
}

/**
 * Init
 */
document.addEventListener("DOMContentLoaded", () => {

   const accordions = document.querySelectorAll("main details.accordion");

  // 🔒 sécurité : aucune exécution si rien n'existe
  if (accordions.length === 0) return;
  
  ajouterContainersAccordion();
  deplierPremierBlocParDefaut();
  ouvrirBoutonIcon();
  fermerBoutonIcon();
  activerComportementAccordion();
});


// pour l'impression on ouvre les blocs pour que tout soit visible 
window.addEventListener('beforeprint', () => {
  document.querySelectorAll('details.accordion').forEach(details => {
    details.dataset.wasOpen = details.open ? '1' : '0';
    details.open = true;
  });
});

window.addEventListener('afterprint', () => {
  document.querySelectorAll('details.accordion').forEach(details => {
    details.open = details.dataset.wasOpen === '1';
    delete details.dataset.wasOpen;
  });
});